import styled, { css } from 'styled-components';
import { Theme, getBodyStyle, getColor } from 'styles/theme';
import { breakpoint } from 'styles/globals';
import { getIcon } from 'styles/icons';

export const Wrapper = styled.div<{ theme: Theme; $arrowType?: string }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${getColor('surfaceWhite')};

  hr {
    margin-bottom: -24px;
    height: 1px;
    border: none;
    background-color: ${getColor('surfaceSecondary')};
  }

  [role='tabpanel'] {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  padding: 24px 16px;

  @media (${breakpoint.lgMin}) {
    padding: 40px;
  }

  .link-button {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
    color: ${getColor('textWhite')};
    margin-left: auto;
    margin-top: 8px;

    ${({ $arrowType }) => css<{ theme: Theme; $arrowType?: string }>`
    &::after {
      ${getIcon($arrowType || 'next-arrow', 'default')}
    }
  `};
  }
 `;

export const RankingItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-variant-numeric: tabular-nums;
  gap: 16px;

  .spinning-loader {
    margin-left: auto;
    margin-right: auto;
  }
`;
